module.exports = __webpack_public_path__ + "img/next_rounds.b5272e19.jpg";